export default {
  title: "Smartschool",
  description: "Layanan infrastruktur sekolah masa depan",
  //   openGraph: {
  //     type: "website",
  //     locale: "en_IE",
  //     url: "https://www.garymeehan.ie",
  //     title: "Next.js Seo",
  //     description: "SEO made easy for Next.js projects",
  //     image:
  //       "https://prismic-io.s3.amazonaws.com/gary-blog%2F3297f290-a885-4cc6-9b19-3235e3026646_default.jpg",
  //     site_name: "GaryMeehan.ie",
  //     imageWidth: 1200,
  //     imageHeight: 1200,
  //   },
  //   twitter: {
  //     handle: "@garmeeh",
  //     cardType: "summary_large_image",
  //   },
};
